import { HttpClient } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Injectable } from '@angular/core';

import * as fromModel from '@shared/models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    endpoint: string = env.server;

    constructor(private http: HttpClient) {}

    getDashboard(searchQuery: fromModel.ListQueryParams): Observable<any[]> {
        return this.http.post<any[]>(`${this.endpoint}get-dashboard`, searchQuery);
    }
}
